import { ofType } from 'redux-observable';

import { mergeMap, map } from 'rxjs/operators';

import { StripeService } from 'services';
import { PlaidService } from 'services';

import { mappingEpic } from 'redux/ducks/helpers';
import { SHOW_SPINNER, HIDE_SPINNER } from 'redux/ducks/LoadingSpinner';
import { SUCCESS_FLASH_MESSAGE, ERROR_FLASH_MESSAGE } from 'redux/ducks/Flash';

import {
  RETRIEVE_SOURCE,
  RETRIEVE_SOURCE_SUCCESS,
  RETRIEVE_SOURCE_ERROR,
  SUBMIT,
  SUBMIT_ERROR,
  SUBMIT_SUCCESS,
  CREATE_PLAID_ACCESS_TOKEN,
  CREATE_PLAID_ACCESS_TOKEN_SUCCESS,
  CREATE_PLAID_ACCESS_TOKEN_ERROR,
  GET_PLAID_PUBLIC_TOKEN,
  GET_PLAID_PUBLIC_TOKEN_SUCCESS,
  GET_PLAID_PUBLIC_TOKEN_ERROR,
} from './index';
import { CREATE_SESSION_SUCCESS } from '../Session';

// Epics
// ========================================================
export function retrieveSourceEpic(action$, store) {
  return action$.pipe(
    ofType(RETRIEVE_SOURCE),
    mergeMap((action) => {
      return new StripeService(store.getState().session, action.payload)
        .get()
        .then((result) => ({ type: RETRIEVE_SOURCE_SUCCESS, payload: result }))
        .catch((error) => ({ type: RETRIEVE_SOURCE_ERROR, payload: error }));
    })
  );
}

export function mapUpdatePaymentToRetrieveSourceEpics(action$, store) {
  return action$.pipe(
    ofType(SUBMIT_SUCCESS, CREATE_SESSION_SUCCESS),
    map((action) => ({
      type: RETRIEVE_SOURCE,
      payload: store.getState().session.currentUser.id,
    }))
  );
}

export function savePaymentEpic(action$, store) {
  return action$.pipe(
    ofType(SUBMIT),
    mergeMap((action) => {
      if (action.payload.token) {
        return new StripeService(store.getState().session, action.payload.id)
          .update(action.payload.token)
          .then((result) => ({ type: SUBMIT_SUCCESS, payload: result }))
          .catch((error) => ({ type: SUBMIT_ERROR, payload: error }));
      } else {
        return new PlaidService(store.getState().session, action.payload.id)
          .update(action.payload.plaid)
          .then((result) => ({ type: SUBMIT_SUCCESS, payload: result }))
          .catch((error) => ({ type: SUBMIT_ERROR, payload: error }));
      }
    })
  );
}

export function createPlaidPublicTokenEpic(action$, store) {
  return action$.pipe(
    ofType(RETRIEVE_SOURCE_SUCCESS, CREATE_PLAID_ACCESS_TOKEN_SUCCESS),
    map((action) => ({
      type: GET_PLAID_PUBLIC_TOKEN,
      payload: action.payload,
    }))
  );
}

export function getPlaidPublicTokenEpic(action$, store) {
  return action$.pipe(
    ofType(GET_PLAID_PUBLIC_TOKEN),
    mergeMap((action) => {
      return new PlaidService(store.getState().session, action.payload)
        .get()
        .then((result) => ({
          type: GET_PLAID_PUBLIC_TOKEN_SUCCESS,
          payload: result,
        }))
        .catch((error) => ({
          type: GET_PLAID_PUBLIC_TOKEN_ERROR,
          payload: error,
        }));
    })
  );
}

export function createPlaidAccessTokenEpic(action$, store) {
  return action$.pipe(
    ofType(CREATE_PLAID_ACCESS_TOKEN),
    mergeMap((action) => {
      return new PlaidService(store.getState().session, action.payload.id)
        .createAccessToken(action.payload.token)
        .then((result) => ({
          type: CREATE_PLAID_ACCESS_TOKEN_SUCCESS,
          payload: result,
        }))
        .catch((error) => ({
          type: CREATE_PLAID_ACCESS_TOKEN_ERROR,
          payload: error,
        }));
    })
  );
}

export function createPlaidAccessTokenSuccessFlashEpic(action$, store) {
  return action$.pipe(
    ofType(CREATE_PLAID_ACCESS_TOKEN_SUCCESS),
    map((_) => ({
      type: SUCCESS_FLASH_MESSAGE,
      payload: {
        message:
          'Micro-deposits can take up to 1 business day. You will receive an email when it has been deposited. Please return to this page to verify.',
      },
    }))
  );
}

export function createPlaidAccessTokenErrorFlashEpic(action$, store) {
  return action$.pipe(
    ofType(CREATE_PLAID_ACCESS_TOKEN_ERROR),
    map((_) => ({
      type: ERROR_FLASH_MESSAGE,
      payload: 'There has been an error.',
    }))
  );
}

export const showSpinnerEpic = mappingEpic(
  [
    CREATE_PLAID_ACCESS_TOKEN,
    RETRIEVE_SOURCE,
    SUBMIT,
    CREATE_PLAID_ACCESS_TOKEN,
    GET_PLAID_PUBLIC_TOKEN,
  ],
  SHOW_SPINNER
);

export const hideSpinnerEpic = mappingEpic(
  [
    RETRIEVE_SOURCE_SUCCESS,
    RETRIEVE_SOURCE_ERROR,
    SUBMIT_SUCCESS,
    SUBMIT_ERROR,
    CREATE_PLAID_ACCESS_TOKEN_ERROR,
    CREATE_PLAID_ACCESS_TOKEN_SUCCESS,
    GET_PLAID_PUBLIC_TOKEN_SUCCESS,
    GET_PLAID_PUBLIC_TOKEN_ERROR,
  ],
  HIDE_SPINNER
);
